import React from 'react';
import Toolbar from '../toolbar.component';

export { separator } from '../toolbar.component';

const toolbarPlugin = actions => ({
  renderEditor: (event, editor, next) => { // eslint-disable-line react/display-name
    const children = next();

    return (
      <>
        <Toolbar actions={actions} editor={editor} readOnly={editor.readOnly} />
        {children}
      </>
    );
  },
});

export default toolbarPlugin;
